<template>
    <div class="tabs-container">
        <div class="tabs-header">
            <Button
                v-for="tab in tabs"
                :key="tab.id"
                :className="activeTabId === tab.id ? 'blueBtn' : 'whiteBtn'"
                :onClick="() => $emit('update:activeTabId', tab.id)"
                :text="$t(tab.label)"
                class="tab-button"
            />
        </div>
        <div class="tabs-content">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Button from '@/components/ui-components/Button.vue';

interface Tab {
    id: string;
    label: string;
}

export default defineComponent({
    name: 'Tabs',
    components: {
        Button,
    },
    props: {
        tabs: {
            type: Array as PropType<Tab[]>,
            required: true,
        },
        activeTabId: {
            type: String,
            required: true,
        },
    },
    emits: ['update:activeTabId'],
});
</script>

<style scoped>
.tabs-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.tabs-header {
    display: flex;
    gap: 20px;
    padding-bottom: 10px;
    flex-wrap: wrap;
}
.tab-button {
    min-width: 120px;
    flex: 0 1 auto;
}
.tabs-content {
    padding-top: 10px;
    flex: 1;
    min-height: 0;
}
</style>
